import styled from 'styled-components'

export const ErrorPanel = styled.div`
    margin: auto;
    width: 100px;
`
export const SummaryStyle = styled.div`
    ${({ theme }) => theme.fonts.Montserrat['s32-ln40-fw800']};
    width: 450px;
    height: 50px;
    margin: auto;
`
export const DetailsStyle = styled.div`
    ${({ theme }) => theme.fonts.Montserrat['s16-ln20-fw400']};
    width: 650px;
    height: 30px;
    margin: auto;
`
